export default __webpack_public_path__ + "static/screenshot2-5e645146975039fa0ca86a0f5bc1332c.jpg";